module.exports = __webpack_public_path__ + "img/btn_menu-close.c3e36285.png";